<script lang="ts">
import type { ThemeSlots } from '#layers/ui/types/tv';
import { tv } from 'tailwind-variants';

const errorStateClasses = tv({
	slots: {
		root: '',
		icon: 'border-error/25 text-error',
		title: '',
		description: '',
		action: '',
	},
});

export interface ErrorStateProps {
	icon?: string;
	title?: string;
	description?: string;
	actionButtonLabel?: string;
	actionButtonIcon?: string;
	ui?: ThemeSlots<typeof errorStateClasses>;
}
</script>

<script lang="ts" setup>
import { computed } from 'vue';
import { mergeUi } from '#layers/ui/utils/merge-ui';

const { ui: uiProp } = defineProps<ErrorStateProps>();
const emit = defineEmits<{
	action: [];
}>();

const baseUi = errorStateClasses();
const ui = computed(() => mergeUi({
	root: baseUi.root(),
	icon: baseUi.icon(),
	title: baseUi.title(),
	description: baseUi.description(),
	action: baseUi.action(),
}, uiProp));

function emitAction() {
	emit('action');
}
</script>

<template>
	<DEmpty
		:icon
		:title
		:description
		:action-button-label
		:action-button-icon
		:ui
		@action="emitAction"
	>
		<template v-if="$slots.illustration" #illustration>
			<slot name="illustration" />
		</template>
		<template v-if="$slots.action" #action>
			<slot name="action" />
		</template>
	</DEmpty>
</template>
